(function () {
    'use strict';

    function entityIcon($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/entityIcon.html',
            scope: {
                'iconObject': '=',
                'iconProperty': '@',
                'iconText': '@',
                'iconWidth': '@?',
                'iconHeight': '@?',
                'iconMode': '@?'
            },
            link: function (scope, element, attrs) {
                function parseDimension(val) {
                    if (!val) {
                        return '70';
                    }
                    var parsed = parseInt(val);
                    if (isNaN(parsed)) {
                        return '70';
                    }
                    return val;
                }
                if (!scope.iconMode) {
                    scope.iconMode = 'small';
                }
                scope.canShowIcon = false;
                scope.iconUrl = '';
                scope.isFirstLoad = true;

                scope.truncateLabelLength = attrs['truncateLabelLength'] ?
                    parseInt(attrs['truncateLabelLength'], 10)
                    : 13;
                scope.iconWidth = parseDimension(scope.iconWidth);
                scope.iconHeight = parseDimension(scope.iconHeight);

                scope.showNameBelow = 'showNameBelow' in attrs;

                scope.$watch(function () {
                    return scope.iconObject;
                }, function (newVal) {
                    if (newVal && newVal[scope.iconProperty]) {
                        scope.canShowIcon = true;
                        if (!scope.isFirstLoad) {
                            $timeout(function () {
                                scope.iconUrl = '/files/getlogo?blobReference=' +
                                    scope.iconObject.BlobReference + '&fileName=' + scope.iconObject.FileName +
                                        '&width=' + scope.iconWidth + '&height=' + scope.iconHeight;
                            }, 1000);
                        }
                        else {
                            scope.iconUrl = '/files/getlogo?blobReference=' +
                                    scope.iconObject.BlobReference + '&fileName=' + scope.iconObject.FileName +
                                        '&width=' + scope.iconWidth + '&height=' + scope.iconHeight;
                        }
                    }
                    else {
                        scope.canShowIcon = false;
                        scope.iconUrl = '';
                    }
                    scope.isFirstLoad = false;
                });
            }
        };
    }

    entityIcon.$inject = ['$timeout'];

    angular.module('ecap.common').directive('entityIcon', entityIcon);
})();